<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :handles="handles"
      :query="query"
      :toolbar="toolbar"
      :selection="false"
      label-width="120px"
    />
  </div>
</template>

<script>
// import x from ''
import fieldFilter from '@/utils/fieldFilter.js'
export default {
  name: 'Gaojingshezhi',
  components: {},
  data() {
    return {
      url: '/alarm/alarmSet/page',
      columns: [
        {
          label: '告警名称',
          prop: 'setName'
        },
        {
          label: '归属运营商',
          prop: 'operatorName'
        }
        // {
        //   label: "运营商属性",
        //   prop: "attr",
        //   template: function(index, reocrd) {
        //     return reocrd.attr === 0 ? "自营" : reocrd.attr === 1 ? "加盟" : "互联互通"
        //   }
        // }
      ],
      // 操作栏
      handles: {
        width: 300,
        btns: [
          {
            label: '详情',
            icon: 'el-icon-view',
            permission: 'alarm.deploy.details',
            handle: resp => {
              this.$router.push({ path: './alarmSettingDetail', query: { data: resp.id }})
            }
          },
          {
            label: '修改',
            icon: 'el-icon-edit',
            permission: 'alarm.deploy.update',
            handle: resp => {
              console.log(resp)
              this.$router.push({ path: './reviseAlarmSetting', query: { data: resp.id }})
            }
          },
          {
            label: '删除',
            permission: 'alarm.deploy.delete',
            style: 'color:red',
            url: '/alarm/alarmSet',
            method: 'delete',
            isConfirm: true,
            before: (index, record) => {
              const arr = []
              arr.push(record.id)
              return {
                ids: arr
              }
            },
            handle: () => {
              this.$refs.tableref.queryTable()
            }
          }
        ]
      },
      query: [
        {
          label: '告警名称',
          prop: 'setName',
          placeholder: '请输入告警名称'
        },
        {
          label: '归属运营商',
          prop: 'operatorName',
          placeholder: '请输入归属运营商'
        },
        {
          label: '运营商属性',
          prop: 'operateStatus',
          placeholder: '请选择运营商属性',
          type: 'select',
          data: [
            {
              label: '自营',
              value: 0
            },
            {
              label: '加盟',
              value: 1
            },
            {
              label: '互联互通',
              value: 2
            }
          ]
        }

      ],
      toolbar: [
        {
          label: '新增',
          permission: 'alarm.deploy.add',
          type: 'primary',
          handle: resp => {
            this.$router.push('./addAlarmSetting')
          }
        }
      ]
    }
  },
  computed: {},
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
</style>



// WEBPACK FOOTER //
// src/views/alarmManagement/stationAlarmSetting.vue